export default {
  root: {
    display: 'inline-block',
    fontSize: 24,
  },
};
